import type { Entity } from "../world/Entity";
import type { SceneDiff } from "../world/scene-diff";
import type { Inventory } from "../inventory/Inventory";
import type { KnowledgeProgress } from "../knowledge/KnowledgeGraph";
import type { QuestProgress } from "../quests/QuestDefinition";

export const CURRENT_SAVE_VERSION = 3;

export interface Preferences {
  readonly musicVolume: number;
  readonly soundVolume: number;
  readonly muted: boolean;
  readonly mcpEnabled: boolean;
  readonly minimapVisible: boolean;
  readonly touchControlsEnabled: boolean;
}

export function defaultPreferences(): Preferences {
  return { musicVolume: 0.7, soundVolume: 0.8, muted: false, mcpEnabled: true, minimapVisible: false, touchControlsEnabled: true };
}

export interface WorldSnapshot {
  readonly currentSceneId: string;
  readonly sceneDiffs: Readonly<Record<string, SceneDiff>>;
  /** @deprecated v2 format — only present in legacy saves, ignored by v3+. */
  readonly scenes?: Readonly<Record<string, readonly Entity[]>>;
  readonly revealedSecrets: readonly string[];
  readonly questProgress: Readonly<Record<string, QuestProgress>>;
}

export interface PlayerSnapshot {
  readonly inventory: Inventory;
  readonly knowledge: KnowledgeProgress;
}

export interface GameSave {
  readonly version: number;
  readonly world: WorldSnapshot;
  readonly player: PlayerSnapshot;
}
